import React from 'react';
import { useInView } from '@/hooks/useInView';

const TIKTOK_VIDEOS = [
  "7606758251174071583",
  "7606763321877957918",
  "7607222972587216158",
  "7606747001652284703",
];

export const TikTokSection = () => {
  const [ref, isInView] = useInView();

  return (
    <section data-testid="tiktok-section" className="py-16 lg:py-24 bg-background" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center mb-10 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <h3 className="text-foreground text-2xl sm:text-3xl font-bold">Find Me on TikTok</h3>
          <a
            href="https://www.tiktok.com/@sara_google_ads"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary font-medium mt-2 inline-block hover:underline"
            data-testid="tiktok-link"
          >
            @sara_google_ads
          </a>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {TIKTOK_VIDEOS.map((videoId, i) => (
            <div
              key={videoId}
              className={`rounded-xl overflow-hidden shadow-[var(--shadow-card)] bg-card border border-border transition-all duration-700 ${
                isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${150 + i * 100}ms` }}
            >
              <iframe
                src={`https://www.tiktok.com/embed/v2/${videoId}`}
                className="w-full border-0"
                style={{ height: '500px' }}
                allowFullScreen
                allow="encrypted-media"
                title={`TikTok video ${i + 1}`}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
